import { Input } from "reactstrap";
import Constants from "utils/Constants";

const SubitemRecordName = ({ fieldValues, setFieldValues }) => {
  const filteredFields = fieldValues.subitemFields.filter((f) =>
    Constants.RECORD_NAME_FIELDTYPES.includes(f.FieldType)
  );

  return (
    <div className="mx-2">
      <h4 className="mb-0">Record Name</h4>
      <small>
        Choose a field to be used as the Record Name for this subitem field.
      </small>
      <Input
        onChange={onChange}
        value={fieldValues?.subitemRecordNameField ?? ""}
        type="select"
        bsSize="sm"
        className="mt-2"
      >
        <option disabled value="">
          No Field Selected
        </option>
        {filteredFields.map((f) => (
          <option key={f.APIName} value={f.APIName}>
            {f.Name}
          </option>
        ))}
      </Input>
    </div>
  );

  function onChange(e) {
    const newField = e.target.value;

    setFieldValues((prev) => ({ ...prev, subitemRecordNameField: newField }));
  }
};

export default SubitemRecordName;
